export default __webpack_public_path__ + "static/normalized_decrypt-0ba3e319a2ae8f4edfc6ef0b1de28772.svg";